import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router'
import BillingStore from '../../../stores/billing'
import classnames from 'classnames'
import { formatDate } from '../../../utils/format'
import PlanRadioButton from './PlanRadioButton'
import { ensureStripeLoaded } from '../../../stripe'

// const plans = {
//   essentials: 'Standard',
//   newPremium: 'Premium'
// }

const rates = {
  monthly: 'Monthly',
  yearly: 'Yearly'
}
@withRouter
@inject('auth')
@observer
export default class BillingActivate extends Component {

  state = {
    store: new BillingStore(),
    processing: false,
    agreeMissing: false,
    stripeLoaded: !!window.stripe,
  }

  componentWillMount() {
    this.state.store.loadLicense().then(() => {
      const { store } = this.state
      if (store.license && store.license.status !== 'Active') {
        this.updateToLatestPlan()
      }
    })
  }

  componentDidMount() {
    this.stripeInterval = ensureStripeLoaded(() => this.setState({ stripeLoaded: true }))
  }

  updateToLatestPlan() {
    const { store } = this.state
    const license = store.license

    if (!license) return

    const planType = license.plan
    const fullPlan = license.full_plan_name
    let newPlan

    if (planType === 'essentials') {
      newPlan = `essentials_${license.rate}_APR26`
    } else if (planType === 'new_premium') {
      newPlan = `premium_${license.rate}_APR26`
    } else {
      return
    }

    if (fullPlan === newPlan) return

    store.updateLicense({ plan: newPlan })
  }

  componentWillUnmount() {
    clearInterval(this.stripeInterval)
  }

  handleCardRef = el => {
    if (!el) return
    const elements = window.stripe.elements()
    this.card = elements.create('card',{
      hidePostalCode : true,
    })
    this.card.mount(el)
  }

  handleBillingAddressRef = el => {
    if (!el) return
    const elements = window.stripe.elements()
    this.address = elements.create('address', { mode: 'billing' })
    this.address.mount(el)
  }

  handleAgreeChange = e => {
    this.setState({ 
      agreeMissing: !e.target.checked,
      cardError: e.target.checked ? null : 'You must agree.'
    })
  }

  handlePlanChange = e => {
    this.setState({ processing: true, processingRate: true })

    const { store } = this.state
    const input = e.target
    const other = input.value === 'essentials' ? 'new_premium' : 'essentials'
    const planType = input.checked ? input.value : other

    let confirmed = true
    let newPlan
    if (planType === 'essentials') {
      confirmed = confirm('This will reset any Premium Settings. Are you sure?')
      newPlan = this.currentEssentialsPlanOffering()
    } else {
      newPlan = this.currentPremiumPlanOffering()
    }

    if (!confirmed) {
      this.setState({ processing: false, processingRate: false })
      return
    }

    store.updateLicense({
      plan: newPlan
    }).then(() => this.setState({ processing: false, processingRate: false }))
  }

  handleRateChange = e => {
    this.setState({ processing: true, processingRate: true })

    const { store } = this.state
    const input = e.target
    const valueNotSelected = input.value === 'monthly' ? 'yearly' : 'monthly'
    const plan = store.license.full_plan_name.replace(valueNotSelected, input.value)

    store.updateLicense({
      plan
    }).then(() => this.setState({ processing: false, processingRate: false }))
  }

  activate = e => {
    e.preventDefault()

    if (!e.target.elements.namedItem("agree").checked) {
      this.setState({ agreeMissing: true, cardError: 'You must agree.' })
      return
    }

    this.address.getValue()
      .then((data) => {
        if(!data.complete){
          this.setState({ processing: false, cardError: 'You must enter billing details.' })
        }else {
          this.setState({ processing: true, cardError: null })
          window.stripe.createToken(this.card , this.billingCardData(data))
            .then(({ token, error }) => {
              if (error) {
                this.setState({ processing: false, cardError: error.message })
              } else {
                this.card.clear()
                this.address.clear()
                return this.state.store.activateSubscription(token.id , this.billingCustomerData(data)).then(() => {
                  return this.props.auth.load()
                })
              }
            })
            .then(() => {
              this.props.router.push('/billing')
            })
            .catch(() => {
              this.setState({ processing: false, cardError: 'There was a problem saving your card. Please check that it is valid or try again later.' })
            })
        }
      }).catch(() => {
      this.setState({ processing: false, cardError: 'There was a problem saving your card. Please check that it is valid or try again later.' })
    })
  }

  billingData(data, keyMapping) {
    const address = (data && data.value && data.value.address) || {}

    return {
      name: (data && data.value && data.value.name) || '',
      [keyMapping.line1]: address.line1 || '',
      [keyMapping.line2]: address.line2 || '',
      [keyMapping.city]: address.city || '',
      [keyMapping.state]: address.state || '',
      [keyMapping.postal_code]: address.postal_code || '',
      [keyMapping.country]: address.country || '',
    }
  }
  billingCardData(data){
    return this.billingData(data, {
      line1: 'address_line1',
      line2: 'address_line2',
      city: 'address_city',
      state: 'address_state',
      postal_code: 'address_zip',
      country: 'address_country',
    })
  }
  billingCustomerData(data) {
    return this.billingData(data, {
      line1: 'line1',
      line2: 'line2',
      city: 'city',
      state: 'state',
      postal_code: 'postal_code',
      country: 'country',
    })
  }

  yearlySavings() {
    const { license } = this.state.store
    const { rates } = license.invoice_breakdown

    const currentPlan = license.full_plan_name
    let monthlyPlan
    let yearlyPlan

    if (currentPlan.includes('monthly')) {
      monthlyPlan = currentPlan
      yearlyPlan = monthlyPlan.replace('monthly', 'yearly')
    } else {
      yearlyPlan = currentPlan
      monthlyPlan = yearlyPlan.replace('yearly', 'monthly')
    }

    const monthly = rates.find(r => r.plan === monthlyPlan)
    const yearly = rates.find(r => r.plan === yearlyPlan)

    if (!monthly || !yearly) {
      return 0
    }

    return (monthly.cost * 12) - yearly.cost
  }

  planPrice(plan) {
    const { license } = this.state.store
    const { rates } = license.invoice_breakdown

    const rate = rates.find(r => r.plan === plan)
    return rate ? rate.cost : 0
  }

  currentEssentialsPlanOffering() {
    const { store: { license } } = this.state

    if (license && license.status && license.status === 'Active') {
      return license.full_plan_name ? license.full_plan_name : `essentials_${license.rate}`
    } else {
      return `essentials_${license.rate}_APR26`
    }
  }

  currentPremiumPlanOffering() {
    const { store: { license } } = this.state

    if (license && license.status && license.status === 'Active') {
      return license.full_plan_name ? license.full_plan_name : `new_premium_${license.rate}`
    } else {
      return `premium_${license.rate}_APR26`
    }
  }

  render() {
    const { cardError, agreeMissing, processing, store: { license } } = this.state
    const { trial_info } = this.props.auth.user

    if (!license || !trial_info) return <div className="loading">Loading...</div>

    const plural = trial_info.days_remaining != 1
    const trial_message = trial_info.expired
      ? 'Your Trial Has Expired'
      : `You Have ${trial_info.days_remaining} Day${plural ? 's' : ''} Left In Your Trial`
    const invoice_message = trial_info.expired
      ? `You will not be billed until your trial ends on ${formatDate(license.trial_ends_at)}.`
      : 'Your trial has expired and you will be billed immediately.'
    const banner_message = trial_info.expired
      ? 'You must subscribe to continue service.\nEnter your billing information to activate your Showcase IDX account.'
      : `Enter your billing information to activate your Showcase IDX account.\nYou won't be billed until the end of your trial on ${formatDate(license.trial_ends_at)}.`

    return (
      <div className="container centered padded subscribe">
        <div className={classnames("panel full padded", {
          caution: trial_info.days_remaining <= 2,
          danger: trial_info.expired,
        })}>
          <div style={{fontSize: '2em', textAlign: 'center'}}>
            {trial_message}
          </div>
        </div>

        <div style={{textAlign: 'center', whiteSpace: 'pre', width: '100%', marginBottom: '20px', fontSize: '1.2em'}}>
          {banner_message}
        </div>

        <div className="panel half padded">
          <h2 className="title">Billing Frequency</h2>
          <PlanRadioButton
            selected={license.full_plan_name.includes('yearly')}
            disabled={processing}
            onChange={this.handleRateChange}
            name="rate"
            value="yearly"
            primaryLeft={<span>Yearly <em>Recommended</em></span>}
            primaryRight={<strong>Save ${this.yearlySavings().toFixed(2)}</strong>}
            secondaryLeft="Pay up front and save!"
            secondaryRight="Per year on the Premium Plan" />
          <PlanRadioButton
            selected={license.full_plan_name.includes('monthly')}
            disabled={processing}
            onChange={this.handleRateChange}
            name="rate"
            value="monthly"
            primaryLeft="Monthly"
            secondaryLeft="Pay-as-you-go." />
        </div>

        <div className="panel half padded">
          <h2 className="title">Billing Summary</h2>
          <table>
            <tbody>
              {license.invoice_breakdown.items.map(item => (
                <tr key={item.plan}>
                  <td style={{ padding: '5px 0' }}>{item.name}{item.quantity > 1 ? ` (${item.quantity} @ $${item.cost.toFixed(2)} ea.)` : null}</td>
                  <td style={{ padding: '5px 0', textAlign: 'right' }}>${(item.cost * item.quantity).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop: '10px', paddingTop: '10px', fontWeight: 'bold', textAlign: 'right', borderTop: '1px solid #eee' }}>{rates[license.rate]} Total: ${license.invoice_breakdown.total.toFixed(2)}</div>
          <p style={{ fontSize: '.8em', color: '#666', textAlign: 'center' }}>{invoice_message}</p>
        </div>

        <div className="panel half padded">
          <h2 className="title">Choose Your Plan</h2>
          <PlanRadioButton
            selected={license.plan === 'new_premium'}
            disabled={processing}
            onChange={this.handlePlanChange}
            name="plan"
            value="new_premium"
            primaryLeft={<span>Premium <em>Recommended</em></span>}
            primaryRight={`$${this.planPrice(this.currentPremiumPlanOffering()).toFixed(2)}/${license.rate === 'monthly' ? 'mo' : 'yr'}.`}
            secondaryLeft="More Settings + Premium Listing Content + Lead Routing + More" />
          <PlanRadioButton
            selected={license.plan === 'essentials'}
            disabled={processing}
            onChange={this.handlePlanChange}
            name="rate"
            value="essentials"
            primaryLeft="Essentials"
            primaryRight={`$${this.planPrice(this.currentEssentialsPlanOffering()).toFixed(2)}/${license.rate === 'monthly' ? 'mo' : 'yr'}.`}
            secondaryLeft="Everything you need to engage consumers on your website." />
        </div>

        <div className="panel half padded">
          <h2 className="title">Billing Details</h2>
          <div className="payment">
            <form onSubmit={this.activate}>
              {this.state.stripeLoaded && <div>
                <div ref={this.handleBillingAddressRef} ></div>
                <div ref={this.handleCardRef} style={{maxHeight:'55px',marginTop:'1px'}}></div>
              </div>}
              <div className={classnames('agree', { missing: agreeMissing })} style={{position:'relative',zIndex:'99'}}>
                <input type="checkbox" name="agree" id="agree" onChange={this.handleAgreeChange} disabled={processing} />
                <label htmlFor="agree">I agree to the Showcase IDX Terms of Service and authorize them to bill me {license.rate} for service.</label>
              </div>
              <button className="button success block big" style={{position:'relative',zIndex:'99'}} disabled={processing}>
                <i className={classnames('fa', {
                  'fa-check': !processing,
                  'fa-spinner': processing,
                  'fa-spin': processing,
                })} />
                &nbsp; Activate Subscription
              </button>
              {cardError && <div className="error">{cardError}</div>}
            </form>
          </div>
        </div>

        <div style={{textAlign: 'center', width: '100%'}}>
          Questions? Call us at <a href="tel:8004780181">800-478-0181</a> or email us: <a href="mailto:help@showcaseidx.com">help@showcaseidx.com</a>
        </div>

        { processing ? <i className="processing fa fa-spinner fa-spin" /> : null }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Billing/Activate.js